import { FC, memo } from 'react'
import { Button } from '@cargomart/ui'
import { useMockOrderYarcheCreate } from 'hooks/useMockOrderYarcheCreate'

interface MockOrderYarcheDataProps {
  excludes?: string[]
}

export const MockOrderYarcheData: FC<MockOrderYarcheDataProps> = ({ excludes = [] }) => {
  const { setMockData, isCanMock } = useMockOrderYarcheCreate({ excludes })

  if (!isCanMock) {
    return <></>
  }

  return (
    <div className="fixed left-1 top-[106px] z-notice flex flex-col gap-y-2 pl-2 opacity-[0.8]">
      <Button onClick={setMockData} size="sm">
        Заполнить форму
      </Button>
    </div>
  )
}
export default memo(MockOrderYarcheData)
